<div class="header">
  <h2>What's New</h2>
  <a href="./bite/site/whats-new" class="view-more">View more posts
    <i class="fas fa-chevron-right"></i>

  </a>

</div>
@if (newestContent) {
  <div class="whats-new-container">
    <a class="first-item" [href]="newestContent[0].link">
      <div class="first-item-text">
        <div class="item-type">
          {{ !!newestContent[0].display_type && newestContent[0].display_type.length>0 ? newestContent[0].display_type : newestContent[0].type | uppercase}}
        </div>
        <div class="first-item-title">
          {{newestContent[0].title}}
        </div>
        @if (newestContent[0].description) {
          <div class="first-item-description"
            >
            {{newestContent[0].description}}
          </div>
        }
      </div>
      @if (newestContent[0].imageUrl && newestContent[0].imageUrl.length) {
        <div class="first-item-image"
          >
          <img [src]="newestContent[0].imageUrl"/>
        </div>
      }
    </a>
    <div class="other-items">
      @for (item of newestContent.slice(1); track item; let i = $index) {
        <a class="small-item"
          [href]="item.link"
          >
          <div class="item-type">
          {{ !!item.display_type && item.display_type.length>0 ? item.display_type : item.type | uppercase}}</div>
          <div class="small-item-title">{{item.title}}</div>
        </a>
      }
    </div>
  </div>
}

